import Swiper, { Navigation, Pagination, Autoplay, Grid, Thumbs } from "swiper";

window.Swiper = Swiper;

function merge(modules, settings) {
    for (var key in settings) {
        if (settings.hasOwnProperty(key)) modules[key] = settings[key];
    }
    return modules;
}

window.initSwiper = function (slider) {
    let settings = {};
    let modules = { modules: [] };

    settings["modules"] = [];
    if (slider.dataset.modulenav) {
        modules["modules"].push(Navigation);
    }

    if (slider.dataset.modulepagination) {
        modules["modules"].push(Pagination);
    }

    if (slider.dataset.moduleautoplay) {
        modules["modules"].push(Autoplay);
    }

    if (slider.dataset.modulegrid) {
        modules["modules"].push(Grid);
    }

    if (slider.dataset.modulethumbs) {
        modules["modules"].push(Thumbs);
    }

    if (slider.dataset.settings) {
        settings = JSON.parse(slider.dataset.settings);
    }

    settings = merge(modules, settings);
    let swiper = new Swiper(slider, settings);

    // Handle thumbnail swiper initialization
    if (slider.dataset.thumbsSwiper) {
        const thumbsSwiperEl = document.querySelector(
            slider.dataset.thumbsSwiper,
        );
        if (thumbsSwiperEl) {
            const thumbsSwiper = new Swiper(thumbsSwiperEl, {
                modules: [Thumbs],
                spaceBetween: 8,
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesProgress: true,
            });
            swiper.thumbs.swiper = thumbsSwiper;
            thumbsSwiper.thumbs.swiper = swiper;
        }
    }

    return swiper;
};

// Initialize product thumbnails before regular sliders
function initProductThumbnails() {
    const productMainSwipers = document.querySelectorAll(
        ".product-main-swiper",
    );
    productMainSwipers.forEach((mainSwiperEl) => {
        if (mainSwiperEl.swiper) return; // Already initialized

        const productId = mainSwiperEl.id.replace("product-main-swiper-", "");
        const thumbsSwiperEl = document.getElementById(
            "product-thumbs-swiper-" + productId,
        );

        if (thumbsSwiperEl) {
            // Initialize thumbs swiper first
            const thumbsSettings = thumbsSwiperEl.dataset.settings
                ? JSON.parse(thumbsSwiperEl.dataset.settings)
                : {};
            const thumbsSwiper = new Swiper(thumbsSwiperEl, {
                modules: [Thumbs],
                ...thumbsSettings,
            });

            // Initialize main swiper with thumbs
            const mainSettings = mainSwiperEl.dataset.settings
                ? JSON.parse(mainSwiperEl.dataset.settings)
                : {};
            const mainModules = [];
            if (mainSwiperEl.dataset.modulenav) mainModules.push(Navigation);
            if (mainSwiperEl.dataset.moduleautoplay) mainModules.push(Autoplay);
            mainModules.push(Thumbs);

            const mainSwiper = new Swiper(mainSwiperEl, {
                modules: mainModules,
                thumbs: {
                    swiper: thumbsSwiper,
                },
                ...mainSettings,
            });

            // Add active state styling to thumbnails
            function updateThumbActiveState() {
                // Use realIndex for loop mode, activeIndex otherwise
                const activeIndex =
                    mainSwiper.realIndex !== undefined
                        ? mainSwiper.realIndex
                        : mainSwiper.activeIndex;

                // Update active state styling on thumbnails
                if (thumbsSwiper && thumbsSwiper.slides) {
                    thumbsSwiper.slides.forEach((slide, index) => {
                        const thumb = slide.querySelector(".product-thumb");
                        if (thumb) {
                            if (index === activeIndex) {
                                thumb.classList.add("!border-gray-900");
                                thumb.classList.remove(
                                    "border-transparent",
                                    "border-gray-400",
                                );
                            } else {
                                thumb.classList.remove("!border-gray-900");
                                thumb.classList.add("border-transparent");
                            }
                        }
                    });
                }
            }

            // Update on slide change (works for arrows, swipes, thumbnails, etc.)
            // The Thumbs module handles syncing automatically, we just need to update styling
            mainSwiper.on("slideChange", function () {
                updateThumbActiveState();
            });

            mainSwiper.on("slideChangeTransitionEnd", function () {
                updateThumbActiveState();
            });

            // Initial state
            updateThumbActiveState();
        }
    });
}

// Initialize product thumbnails first
initProductThumbnails();

// Then initialize regular sliders (skip product main swipers as they're already initialized)
let sliders = document.querySelectorAll(
    ".swiper-slider:not(.product-main-swiper)",
);
sliders.forEach((slider) => {
    if (!slider.swiper) {
        window.initSwiper(slider);
    }
});
